import { Button, Tooltip, styled } from '@mui/material';
import { forwardRef } from 'react';
import Iconify from 'src/components/iconify';
import { ActionButtonProps } from './types';

export const ActionButton = forwardRef<any, ActionButtonProps>(
  (
    {
      onClick,
      tooltip,
      children,
      placement = 'top',
      variant = 'soft',
      className,
      ...rest
    },
    ref,
  ) => (
    <Tooltip placement={placement} arrow title={tooltip}>
      <span className={className}>
        <StyledButton
          ref={ref}
          size="small"
          onClick={onClick}
          variant={variant}
          disableElevation
          {...rest}
        >
          {children}
        </StyledButton>
      </span>
    </Tooltip>
  ),
);

const StyledButton = styled(Button)(({ theme }) => ({
  width: 40,
  height: 40,
  minWidth: 'unset',
  '&:hover': {
    boxShadow: 'none',
  },
}));

export const StyledIcon = styled(Iconify)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: 24,
    height: 24,
  },
}));
